import { render, staticRenderFns } from "./interaction.vue?vue&type=template&id=f23b3c7a"
import script from "./interaction.vue?vue&type=script&lang=js"
export * from "./interaction.vue?vue&type=script&lang=js"
import style0 from "./interaction.vue?vue&type=style&index=0&id=f23b3c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports